import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container purchasesummary-end" }
const _hoisted_3 = { style: {"text-align":"center","line-height":"22px"} }

import { NssiData } from "@/api/NssiData";
import Loader from "@/components/MainLoader.vue";
import { AssurantData } from "@/api/AssurantData";
import { ref } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteDoneFailedRentersApi',
  setup(__props) {

const loading = ref(false);
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;

const getId = async () => {
  try {
    const cartId = await NssiData.toRemote(quote);
    return cartId;
  } catch (error) {
    console.log(error);
  }
};

const retryIssuePolicy = async () => {
  loading.value = true;

  if (quote.rentersInsurance && !quote.assurantPassed) {
    const result = await AssurantData.issuePolicy(quote);
    if (result.error) {
      quote.assurantPassed = false;
      quote.assurantPolicyError = result.message;
      loading.value = false;
      quote.setQuoteStep("quote-done-assurant-failed-api");
      return;
    } else {
      quote.assurantPassed = true;
      quote.rentersInsurance.policyNumber =
        result.result.transactionDetails.policyId;
      quote.assurantPolicyError = "";
    }
  }

  if (quote.personalInsurance && !quote.nssiPassed) {
    const result = await NssiData.issuePolicy(quote, user, getId);

    if (result.error) {
      quote.nssiPassed = false;
      quote.nssiPolicyError = result.message;
      loading.value = false;
      quote.setQuoteStep("quote-done-nssi-failed-api");
      return;
    } else {
      quote.nssiPassed = true;
      //quote.personalInsurance.orderId = result.policy.PolicyID;
      quote.personalInsurance.policyNumber = result.policy;
      quote.nssiPolicyError = "";
    }
  }

  loading.value = false;
  quote.setQuoteStep("quote-done");
};

function quoteDone() {
  quote.done = true;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
      _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
      _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
      _cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "title",
        style: {"text-align":"center","color":"#333"}
      }, " Something went wrong. ", -1)),
      _cache[15] || (_cache[15] = _createElementVNode("p", { style: {"text-align":"center","margin-top":"4px","line-height":"22px"} }, " Please try again. ", -1)),
      _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
      _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("table", {
        width: "100%",
        style: {"max-width":"600px"},
        border: "0",
        cellspacing: "0",
        cellpadding: "0",
        class: "mobilecollpasetable",
        align: "center"
      }, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", {
              valign: "top",
              class: "error"
            }, [
              _createElementVNode("table", {
                width: "100%",
                border: "0",
                cellspacing: "0",
                cellpadding: "0"
              }, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[9] || (_cache[9] = _createElementVNode("td", {
                      width: "20%",
                      valign: "top"
                    }, [
                      _createElementVNode("span", { class: "bigerror-x" })
                    ], -1)),
                    _createElementVNode("td", { valign: "top" }, [
                      _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Your Renters Insurance", -1)),
                      _createElementVNode("div", { class: "try" }, [
                        _cache[4] || (_cache[4] = _createTextVNode(" Things you can try...", -1)),
                        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: retryIssuePolicy
                            }, "Retry"),
                            _cache[1] || (_cache[1] = _createTextVNode(" transaction ", -1)),
                            _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))
                          ]),
                          _cache[3] || (_cache[3] = _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              href: "https://www.nssi.com/contact-us",
                              target: "_blank"
                            }, " Contact NSSI "),
                            _createTextVNode(" for help or to report an issue"),
                            _createElementVNode("br")
                          ], -1))
                        ])
                      ]),
                      _cache[7] || (_cache[7] = _createElementVNode("b", null, [
                        _createTextVNode("Failed! You're "),
                        _createElementVNode("u", null, "NOT"),
                        _createTextVNode(" Covered.")
                      ], -1)),
                      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
      _cache[19] || (_cache[19] = _createElementVNode("hr", null, null, -1)),
      _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
      _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("p", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: { name: 'home' },
          onClick: _cache[0] || (_cache[0] = ($event: any) => (quoteDone()))
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("Return to homepage", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})